module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAAAyMjIxMTEzMzMzMzMzMzMyMjIzMzMzMzMzMzMzMzMyMjIzMzMzMzMzMzMzMzMzMzMyMjI0NDQ0NDQzMzMzMzMyMjIzMzNeDEMeAAAAF3RSTlMAgCpV1EE5+PPo2Uky3+3ipWBPspVtJN9dNUYAAACvSURBVDjLrdJJEoQgEETRAhUVxakH7n/TtgqIWiRBb8wN6vsRbqAn9uq7OnTh4MPEGLuq32Du8xtLgR6tPI2pQB/z1ysV6Fd5WyYt1KeFCArwsmFLhfo2qEoxc6E+Z9e5VBR3BHO7FOI7O2wNXLCHFVUKH2U+O856cYtSZjgwTZei5X3PRcOt1aLqRFrUHQpwKMChANcCHApwKNCxcOpY8L061bE45Rfv5FgcH/q/HxDQEWqubCZ6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fc/close.png
// module id = 2voo
// module chunks = 0